import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import {setError} from "../../streamedChat/streamedChat";
import {setDisconnected} from "../realtime/realtimeSlice";

export type CreateRealtimeSessionPayload = {
  user_sub_service_id:number | string;
};

export type CreateRealtimeSessionLoadAction = {
  type: string;
  payload: CreateRealtimeSessionPayload;
};

export type CreateRealtimeSessionData = { data: {
    value:string;
  } };

const CreateRealtimeSession = new ReduxFetchState<CreateRealtimeSessionData, CreateRealtimeSessionPayload, any>(
  "createRealtimeSession",
);

export function* watchCreateRealtimeSession(action: CreateRealtimeSessionLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: CreateRealtimeSessionData = yield axios({
      url: "/api/v1/ai/third-party/create-realtime-session",
      method: "POST",
      headers: { lang },
      data:{
        user_sub_service_id:action.payload.user_sub_service_id
      }
    });
    yield put(CreateRealtimeSession.actions.loadSuccess({data:data.data}));
  } catch (e: any) {
    yield put(setDisconnected());
    yield put(setError({ errorMessage: e.response.data.error ?? "Something went wrong", retry: false,singleError:true }));
    if (e.response.data.status){
      yield put(CreateRealtimeSession.actions.loadSuccess(e?.response));
    }
    yield put(CreateRealtimeSession.actions.loadFailure(e.message));
  }
}

export function* createRealtimeSessionSagas() {
  yield takeEvery(CreateRealtimeSession.actionTypes.load, watchCreateRealtimeSession);
}

export function useCreateRealtimeSession() {
  const { loading, data, ...createRealtimeSessionState } = useAppSelector(
    (state) => state.createRealtimeSession,
  );
  const dispatch = useAppDispatch();

  const dispatchCreateRealtimeSession = useCallback(
    (data:CreateRealtimeSessionPayload) => {
      dispatch(CreateRealtimeSession.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...createRealtimeSessionState,
    dispatchCreateRealtimeSession,
    createRealtimeSessionLoading: loading,
    createRealtimeSessionData: data,
  };
}

export const {
  actionTypes: createRealtimeSessionActionsTypes,
  actions: createRealtimeSessionActions,
  reducer: createRealtimeSessionReducer,
} = CreateRealtimeSession;